import { Injectable } from '@angular/core';
import { Observable, map, combineLatest, switchMap } from 'rxjs';
import * as moment from 'moment';
import { DocumentsFilter } from '../documents-page.types';
import { LanguageService } from '../../../../core/services/language.service';
import { DocumentsFilterService } from './documents-filter.service';
import { UtilsService } from '../../../../core/services/utils.service';
import { DocumentsApiService } from '../../../../core/modules/documents/documents-api.service';
import { DocumentModel, DocumentTypesModel, DocumentType } from '../../../../core/modules/documents/documents.types';

@Injectable({
  providedIn: 'root',
})

export class DocumentsPageService {
  constructor(
    private documentsApiService: DocumentsApiService,
    private languageService: LanguageService,
    private documentsFilterService: DocumentsFilterService,
    private utilsService: UtilsService,
  ) {}

  getDocuments(): Observable<DocumentModel[]> {
    return this.languageService.languageChanges
      .pipe(
        switchMap(() => combineLatest([
          this.documentsApiService.fetchDocuments().pipe(map(this.sortByDocumentsDate.bind(this))),
          this.documentsFilterService.getDocumentsFilter()])),
        map(([documents, filter]) => this.getFilteredDocuments(documents, filter)),
      );
  }

  // В свагере информация о возвращаемых данных отсутствуют
  getDocumentTypes(): Observable<DocumentType[]> {
    return this.languageService.languageChanges
      .pipe(
        switchMap(() => this.documentsApiService.fetchDocumentTypes()),
        map<DocumentTypesModel, DocumentType[]>(this.sortByShortName.bind(this)),
      );
  }

  private sortByShortName(documentTypes: DocumentTypesModel): DocumentType[] {
    return this.utilsService.sortBy(Object.values(documentTypes), 'shortName', 'ASC');
  }

  private sortByDocumentsDate(documents: DocumentModel[]): DocumentModel[] {
    return documents.sort((a: DocumentModel, b: DocumentModel) => moment(b.date).diff(moment(a.date)));
  }

  private getFilteredDocuments(documents: DocumentModel[], filter: DocumentsFilter): DocumentModel[] {
    return this.documentsFilterService.getFilteredDocuments(documents, filter);
  }
}
